{
  "checkoutCart": {
    "forexAdjustmentLabel": "Dollar conversion difference"
  }
}
